module.exports = __webpack_public_path__ + "media/images/Sarabia-8a58d47578a7b0122d1c2b426d24c174.png";